module.exports = __webpack_public_path__ + "assets/img/fdf3-zw.svg";